"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHAudioScene = void 0;
class KHAudioScene extends Phaser.Scene {
    constructor() {
        super("KHAudioScene");
        this.volume = 1;
    }
    play(audio, loop, fade_in, volume = 1, force_restart = false) {
        if (audio == this.current_clip && !force_restart)
            return;
        this.stop();
        if (this.fade_tween) {
            this.fade_tween.stop(1);
        }
        this.audio = this.sound.add(audio, { loop: loop });
        this.audio.play();
        console.log("Now Playing - " + audio);
        this.volume = volume;
        if (fade_in) {
            this.fade_audio(0, volume, 1000);
        }
        else {
            this.audio.volume = volume;
        }
        this.current_clip = audio;
    }
    fade_out(duration) {
        this.fade_audio(this.volume, 0, duration, () => {
            this.stop();
        });
    }
    fade_audio(start, end, time, callback) {
        if (this.fade_tween)
            this.fade_tween.stop();
        this.audio.volume = start;
        this.fade_tween = this.tweens.add({
            targets: this.audio,
            volume: end,
            duration: time,
            onComplete: () => {
                this.fade_tween = null;
                this.volume = end;
            }
        });
    }
    stop() {
        if (!this.audio)
            return;
        this.audio.stop();
        this.audio = null;
        this.current_clip = null;
    }
}
exports.KHAudioScene = KHAudioScene;
